import React, { FC } from "react";
import { MatterEditorVersions } from "@design-system";

type Props = { matterId: number };

export const VersionsHistoryContainer: FC<Props> = () => {
  // const { data, loading, fetchMore } = useQuery<PreviousVersions>(PREVIOUS_VERSIONS_QUERY, {
  //   variables: { matterId, offset: (page - 1) * limit, limit },
  // });

  const timelineEntries = [...[]]
    .sort((a: any, b: any) => b.id - a.id)
    .map((v: any) => ({
      id: v.id,
      author: v.createdBy.displayName,
      timestamp: new Date(v.createdAt),
      change: createChangeText(v.entity, v.operation),
    }));

  return (
    <>
      <MatterEditorVersions timelineEntries={timelineEntries} />
    </>
  );
};

const createChangeText = (entity: string, operation: string): string => {
  return capitaliseFirstLetter(`${operation}d ${transformEntityName(entity)}`.toLocaleLowerCase());
};

const capitaliseFirstLetter = (input: string): string =>
  input.charAt(0).toUpperCase() + input.slice(1);

const transformEntityName = (entityName: string): string => {
  if (entityName.toLowerCase() === "work") {
    return "fee earner";
  }

  return entityName;
};
